<template>
    <div class="relative inline-flex justify-center">
        <div v-show="show" :class="places" class="absolute whitespace-nowrap z-10 bg-cyan-700 -top-9 flex inset-x-auto text-white px-3 py-0.5 rounded-sm">
            {{text}}
            <div class="absolute -bottom-1 transform rotate-45 bg-cyan-700 h-2 w-2"></div>
        </div>
        <div @mousemove="show=true" @mouseleave="show=false">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: String,
        place: String
    },
    data () {
        return {
            show: false,
        }
    },
    computed: {
        places () {
            let p = ''
            if(this.place == 'left') {
                p ='left-0 justify-start'
            }
            if(this.place == 'center') {
                p = 'justify-center'
            }
            if(this.place == 'right') {
                p = 'right-0 justify-end'
            }
            return p
        }
    }
}
</script>